export default "__VITE_ASSET__BQZrrQqL__"